import { Stack } from "@mui/material";

export const ButtonColumn = ({ children, ...props }) => (
  <Stack p={1} spacing={1} {...props}>
    {children}
  </Stack>
);
